import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px',
    minHeight: '50px'
  },
  bar: {
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.common.white,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  barShift: props => ({
    width: `calc(100% - ${props.drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginRight: props.drawerWidth
  }),
  progress: {
    position: 'fixed',
    width: '100%',
    height: 3
  },
  menu: {
    minWidth: '260px'
  },
  headingMenu: {
    paddingTop: 0,
    pointerEvents: 'none',
    paddingBottom: theme.spacing(1.5)
  },
  menuIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.grey[500]
  }
}))
